import { render, staticRenderFns } from "./CalendarPost.vue?vue&type=template&id=5edc647c&scoped=true&"
import script from "./CalendarPost.vue?vue&type=script&lang=js&"
export * from "./CalendarPost.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPost.vue?vue&type=style&index=0&id=5edc647c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc647c",
  null
  
)

export default component.exports